import ChainsChart from './ChainsChart';
import './ChainsChart.scss';

export default ChainsChart;